import zhTW from "@@/src/locales/zh_TW";

export const getLanguage = () => {
  return zhTW;
}

export const getLangList = (...list: any) => {
  const t: any = getLanguage() || {};
  let lang = {};
  list.forEach((k: any) => {
    lang = Object.assign(lang, t[k]);
  });

  return lang;
}